import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Discover() {
  const items = ['Qué significa vivir desconectada de ti.', 'Por qué decides desde heridas, miedo o condicionamientos.', 'Cómo tu Diseño Humano muestra dónde pierdes energía.', 'Por qué algunos patrones no comenzaron contigo.', 'Tres preguntas para comenzar a volver a ti con más presencia.'];
  return <section className="py-16 md:py-20 bg-brand-cream" data-id="element-67">
      <div className="max-w-5xl mx-auto px-6" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-brand-ink mb-10 md:mb-12" data-id="element-70">
            En esta masterclass vas a descubrir:
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-x-10 gap-y-4 max-w-3xl mx-auto" data-id="element-71">
          {items.map((item, index) => {
          const isLastOdd = index === items.length - 1 && items.length % 2 !== 0;
          return <FadeIn key={index} delay={index * 0.08} className={isLastOdd ? 'sm:col-span-2 sm:max-w-md sm:mx-auto' : ''} data-id="element-72">
                <div className="flex items-start gap-4" data-id="element-73">
                  <span className="font-serif text-2xl text-brand-sage leading-none shrink-0 w-8" data-id="element-74">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="font-sans text-brand-ink/80 text-base leading-snug pt-0.5" data-id="element-75">
                    {item}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}